var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.04297 24.125C3.33255 24.125 2.72439 23.872 2.21849 23.3661C1.71259 22.8602 1.45964 22.2521 1.45964 21.5417V4.75H0.167969V2.16667H6.6263V0.875H14.3763V2.16667H20.8346V4.75H19.543V21.5417C19.543 22.2521 19.29 22.8602 18.7841 23.3661C18.2782 23.872 17.6701 24.125 16.9596 24.125H4.04297ZM16.9596 4.75H4.04297V21.5417H16.9596V4.75ZM6.6263 18.9583H9.20964V7.33333H6.6263V18.9583ZM11.793 18.9583H14.3763V7.33333H11.793V18.9583Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWhite);
export default __webpack_public_path__ + "static/media/delete_white.eb23e3a919c94d5445729f54e5a8de7b.svg";
export { ForwardRef as ReactComponent };